
  import {createControllersWithDescriptors, initAppForPageWrapper} from '@wix/yoshi-flow-editor/runtime/esm/viewerScript/wrapper.js';
  
  
            
import wrapController0 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller0 from '/home/builduser/work/988aeed2e9be6ea4/packages/rise-app-site-plugin/src/components/BalanceWidget/viewer.controller.ts';
            import * as _controllerExport0 from '/home/builduser/work/988aeed2e9be6ea4/packages/rise-app-site-plugin/src/components/BalanceWidget/model.ts';
            var controllerExport0 = _controllerExport0;
            


  
  var importedApp = {};


  

    import { initState, initBind } from '@wix/yoshi-flow-editor/runtime/esm/velocycleMobx';
    import { observable } from 'mobx';
    var velocycleMobx = { initState, initBind, observable };
    


  

    import { blocksControllerService } from '@wix/yoshi-flow-editor/runtime/esm/blocks/controllerService'
    

  
var createHttpClient = null;

  

  import { initI18nWithoutICU as initI18n } from '@wix/yoshi-flow-editor/runtime/esm/i18next/init';


  
const multilingualDisabled = false;

  

    var createExperiments = null;
    var createWidgetExperiments = null;
    


  var sentryConfig = {
      DSN: 'https://5463bad232df48319111715b8ebe67cf@sentry.wixpress.com/5895',
      id: 'undefined',
      projectName: 'rise-app-site-plugin',
      teamName: 'ecom-rise-app',
      errorMonitor: true,
    };

  var experimentsConfig = {"scopes":["test"],"centralized":true};

  var translationsConfig = {"icuEnabled":false,"defaultTranslationsPath":"/home/builduser/work/988aeed2e9be6ea4/packages/rise-app-site-plugin/src/assets/locales/messages_en.json","availableLanguages":["en"]};

  var defaultTranslations = {"app.widget.welcome":"Hello","checkoutSlot.paymentDetails.enterStoreCredit.error.general":"We’re experiencing a technical issue on our end. Refresh the page and try again.","creditWidget.memberCredit.label.":"You have {amount} in credit","checkoutSlot.paymentDetails.enterStoreCredit.error.serviceDown":"Sorry, we can't accept credit right now because of a technical issue. Please continue without your credit or try again later.","checkoutSlot.redeemStoreCredit.codeAlreadyInUse.errorMessage":"This code is already in use.","checkoutSlot.redeemStoreCredit.cta":"Apply","checkoutSlot.redeemStoreCredit.upToOrderTotal.warningMessage":"The applied credit amount can be up to your order total.","checkoutSlot.paymentDetails.enterStoreCredit.error.disabled":"Your credit can't be applied right now. Please contact us for more details. ","checkoutSlot.paymentDetails.enterStoreCredit.error.noBalance":"You don’t have any available credit.","app.settings.defaults.greetingsPretext":"to","app.settings.tabs.design":"Design","creditWidget.memberCredit.label":"You have {{amount}} in credit","creditWidget.editWidget.gfpp.label":"Edit Credit Widget","app.settings.tabs.main":"Main","checkoutSlot.paymentDetails.enterStoreCredit.error.wrongCurrency":"The credit currency doesn't match the currency of the site. Change your cart's currency and try again.","checkoutSlot.paymentDetails.enterStoreCredit.error.expired":"Your credit has expired.","checkoutSlot.redeemStoreCredit.title.new":"Use your {{amount}} credit","creditWidget.layersPanel.label":"Credit Balance Widget","checkoutSlot.redeemStoreCredit.creditEmpty.errorMessage":"You don’t have any available credit.","checkoutSlot.redeemStoreCredit.title":"Use your {amount} credit","app.settings.label":"Configure Widget"};

  var fedopsConfig = null;

  import { createVisitorBILogger as biLogger } from '/home/builduser/work/988aeed2e9be6ea4/packages/rise-app-site-plugin/target/generated/bi/createBILogger.ts';

  export const exports = importedApp.exports;

  export const initAppForPage = initAppForPageWrapper({
    initAppForPage: importedApp.initAppForPage,
    sentryConfig: sentryConfig,
    experimentsConfig: experimentsConfig,
    inEditor: false,
    biLogger: biLogger,
    multilingualDisabled,
    projectName: "rise-app-site-plugin",
    biConfig: null,
    appName: "Rise App",
    appDefinitionId: "56c4b3f5-a5f2-46bd-afb7-414136363b23",
    fedopsConfig: fedopsConfig,
    translationsConfig: translationsConfig,
    defaultTranslations: defaultTranslations,
    shouldUseEssentials: true,
    optionalDeps: {
      initI18n,
      createHttpClient,
      createExperiments,
    },
    localeDistPath: "assets/locales",
  });

  const _createControllers = createControllersWithDescriptors({
    initI18n,
    blocksControllerService,
    createHttpClient,
    createExperiments,
    velocycleMobx,
  }, [{ method: controller0,
          wrap: wrapController0,
          exports: controllerExport0,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"scopes":["test"],"centralized":true},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/988aeed2e9be6ea4/packages/rise-app-site-plugin/src/components/BalanceWidget/viewer.controller.ts",
          appName: "Rise App",
          appDefinitionId: "56c4b3f5-a5f2-46bd-afb7-414136363b23",
          projectName: "rise-app-site-plugin",
          componentName: "BalanceWidget",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "56c4b3f5-a5f2-46bd-afb7-414136363b23-itt7g" }, { method: null,
          wrap: null,
          exports: null,
          widgetType: "WIDGET_OUT_OF_IFRAME",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"scopes":["test"],"centralized":true},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/988aeed2e9be6ea4/packages/rise-app-site-plugin/src/components/RiseAppSitePlugin/controller.ts",
          appName: "Rise App",
          appDefinitionId: "56c4b3f5-a5f2-46bd-afb7-414136363b23",
          projectName: "rise-app-site-plugin",
          componentName: "RiseAppSitePlugin",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "f29f072e-b4e6-4820-8cb0-0d5ec2adb378" }],
    false);

    export const createControllers = _createControllers
